import { TabPane, Tabs, ScreenLayout } from '../../../components/index';
import { PermissionGroups } from '../../../domains/permissionGroups/PermissionGroups';
import { Users } from '../../../domains/users/Users';
import { LoginTokens } from '../../../domains/loginsTokens/LoginTokens';

export function Permissions() {
  const tabs = [
    { name: 'Usuários', key: 'USERS', table: Users },
    { name: 'Grupos de permissões', key: 'GROUPS', table: PermissionGroups },
    { name: 'Logins', key: 'TOKEN', table: LoginTokens },
  ];

  return (
    <ScreenLayout title="Usuários e permissões">
      <Tabs
        defaultActiveKey="USERS"
        size="large"
        style={{
          height: 'calc(100vh - 82px)',
          position: 'relative',
          background: 'var(--neutral_lightest)',
        }}
      >
        {tabs.map((tab) => {
          return (
            <TabPane
              tab={tab.name}
              key={tab.key}
              style={{ height: 'calc(100% - 57px)' }}
            >
              <tab.table />
            </TabPane>
          );
        })}
      </Tabs>
    </ScreenLayout>
  );
}
